import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Newspaper, ArrowRight } from "lucide-react";

/**
 * Carte compacte du Brief matinal — teaser en tête du Dashboard.
 * Style sobre : filet fin ivoire, accent navy au hover, pas de bloc plein.
 */
export default function MorningBriefCard() {
  const [brief, setBrief] = useState(null);
  useEffect(() => {
    api.get("/morning-brief").then((r) => setBrief(r.data)).catch(() => {});
  }, []);
  if (!brief) return null;

  return (
    <Link
      to="/brief-matin"
      data-testid="morning-brief-card"
      className="block mb-8 p-5 group transition-colors"
      style={{
        backgroundColor: "var(--th-surface)",
        border: "1px solid var(--th-border)",
        borderRadius: 12,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "var(--th-border-strong)";
        e.currentTarget.style.backgroundColor = "#fbfaf5";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "var(--th-border)";
        e.currentTarget.style.backgroundColor = "var(--th-surface)";
      }}
    >
      <div className="flex items-start gap-4">
        <div className="pt-0.5">
          <Newspaper size={16} style={{ color: "var(--th-text-3)" }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs mb-1" style={{ color: "var(--th-text-3)" }}>
            Brief matinal · dirigeant
          </div>
          <div
            className="leading-snug font-medium"
            style={{ fontSize: 16, color: "var(--th-text)" }}
          >
            {brief.greeting}
          </div>
          <div className="text-sm mt-1" style={{ color: "var(--th-text-2)" }}>
            {brief.headline}
          </div>
        </div>
        <div
          className="hidden md:flex items-center gap-1.5 text-xs shrink-0 pt-1"
          style={{ color: "var(--th-navy)" }}
        >
          Lire le brief complet <ArrowRight size={13} />
        </div>
      </div>
    </Link>
  );
}
